import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import { ScaffolderInputHeader } from '../../../components';
import { CICD_OIDC_SUBJECTS_INFO } from '../infoDoc';
import { useStyles } from '../styles';
import {
  duplicateCicdOidcSubjects,
  validateCicdOidcSubject,
} from '../validation';

const SUBJECT_MAX_LENGTH = 255;

export interface CicdOidcSubjectsInputProps {
  formData: string[];
  onChange: (data: string[]) => void;
  rawErrors: string[];
  maxSubjects?: number;
  disabled?: boolean;
}

export const CicdOidcSubjectsInput = (props: CicdOidcSubjectsInputProps) => {
  const {
    formData,
    onChange,
    rawErrors,
    maxSubjects = 20,
    disabled = false,
  } = props;
  const { classes } = useStyles();

  const showErrors = Boolean(rawErrors?.length);

  const handleAddSubject = () => {
    onChange([...formData, '']);
  };

  const handleSubjectChange = (index: number, value: string) => {
    onChange(formData.map((subject, i) => (i === index ? value : subject)));
  };

  const handleRemoveSubject = (index: number) => {
    onChange(formData.filter((_, i) => i !== index));
  };

  const duplicates = duplicateCicdOidcSubjects(formData);

  return (
    <Box>
      <Box className={classes.inputContainer}>
        <ScaffolderInputHeader
          title="CI/CD OIDC subject claims"
          description="Allow GitHub Actions workflows and Azure DevOps pipelines to read and sync this project's applications."
          infoDoc={CICD_OIDC_SUBJECTS_INFO}
        />
      </Box>
      {formData.map((subject, index) => (
        <Box key={index} className={classes.flexContainer}>
          <Box className={classes.inputContainer}>
            <TextField
              id={`cicd-oidc-subject-${index}`}
              label="Subject claim"
              fullWidth
              variant="outlined"
              size="small"
              slotProps={{ htmlInput: { maxLength: SUBJECT_MAX_LENGTH } }}
              value={subject}
              disabled={disabled}
              onChange={e => handleSubjectChange(index, e.target.value)}
              error={
                showErrors &&
                (!validateCicdOidcSubject(subject) ||
                  duplicates.has(subject.trim()))
              }
            />
          </Box>
          <Box marginBottom={2}>
            <Button
              variant="outlined"
							disabled={disabled}
              color="secondary"
              onClick={() => handleRemoveSubject(index)}
            >
              Remove
            </Button>
          </Box>
        </Box>
      ))}
      <Box className={classes.inputContainer}>
        <Button
          startIcon={<AddIcon />}
					onClick={handleAddSubject}
					color="secondary"
          variant="outlined"
          disabled={disabled || formData.length >= maxSubjects}
        >
          Add Subject
        </Button>
      </Box>
    </Box>
  );
};
